"use client";
import { useState } from "react";
import { useTranslations } from "next-intl";
import Image from "next/image";
import PlaySvg from "@/components/svg/play";

// Маленький client-island: единственная интерактивная часть хироя — превью-видео
// (клик → подменяем картинку на <video>, ховер → лёгкий зум). Вынесен из серверного
// ComplexInfo, чтобы НЕ тянуть весь герой в клиент: LCP-контент (h1/цена/описание)
// теперь в SSR-HTML и красится сразу, не дожидаясь этого бандла.
export default function HeroVideo() {
  const t = useTranslations("start");
  const [showVideo, setShowVideo] = useState(false);

  return (
    <div
      className="group relative md:w-[358px] h-[343px] w-full cursor-pointer clip-p"
      onClick={() => setShowVideo(true)}
    >
      {showVideo ? (
        <video
          className="video absolute inset-0 w-full h-full object-cover bg-black"
          controls
          autoPlay
          aria-label={t("videoAlt")}
          onClick={(e) => e.stopPropagation()}
          onPointerDown={(e) => e.stopPropagation()}
        >
          <source src="video/WhaleMarinaCondo-Ep.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      ) : (
        <>
          <div className="relative w-full overflow-hidden">
            <div className="overflow-hidden relative">
              {/* Превью-видео — НЕ LCP, поэтому без priority/eager: оптимизатор отдаёт
                  ресайз, картинка грузится обычным приоритетом и не конкурирует за
                  канал с реальным LCP (фон hero). */}
              <Image
                className="object-cover сlip-p transition-transform duration-500 ease-out group-hover:scale-105"
                src="/back_v2.avif"
                alt={t("videoPreviewAlt")}
                width={358}
                height={343}
                sizes="358px"
                quality={60}
              />
              {/* Затемнение снимается при ховере — только opacity (композитор). */}
              <div className="absolute inset-0 bg-black opacity-20 сlip-p transition-opacity duration-500 ease-out group-hover:opacity-0"></div>
            </div>
          </div>
          <div className="w-[65px] h-[65px] bg-white bg-opacity-90 absolute top-[45%] right-[40%] rounded-full flex items-center cursor-pointer transition-transform duration-500 ease-out group-hover:scale-110">
            <PlaySvg />
          </div>
        </>
      )}
    </div>
  );
}
